import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/index';

import { ToastComponent } from './toast.component';
import { ToastWrapperComponent } from './wrapper.component';
import { ToastService } from './toast.service';

export { ToastService } from './toast.service';
export { ToastComponent } from './toast.component';
export { ToastWrapperComponent } from './wrapper.component';

@NgModule({
  declarations: [
    ToastComponent,
    ToastWrapperComponent
  ],
  imports: [
    CommonModule,

    ButtonModule
  ],
  exports: [
    ToastComponent,
    ToastWrapperComponent
  ],
  providers: [
    ToastService
  ]
})
export class ToastModule {}
